<div mat-dialog-content>
  <div class="mat-dialog-header">
    <h3>Selecione um documento para visualizá-lo</h3>
  </div>
  <div class="mat-dialog-content">
    @if (!isLoading) {
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12">
          <div>
            @if (reportDictionary.medicalCareReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('medicalCareReport')">
                  <span>
                    Ficha de atendimento
                  </span>
                  <mat-icon>{{reportDictionary.medicalCareReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.admissionReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('admissionReport')">
                  <span>
                    Relatório de admissão
                  </span>
                  <mat-icon>{{reportDictionary.admissionReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.blankMedicalCareReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('blankMedicalCareReport')">
                  <span>
                    Ficha de atendimento médico
                  </span>
                  <mat-icon>{{reportDictionary.blankMedicalCareReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.wristbandReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('wristbandReport')">
                  <span>
                    Pulseira
                  </span>
                  <mat-icon>{{reportDictionary.wristbandReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.examInternalReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('examInternalReport')">
                  <span>
                    Exames internos
                  </span>
                  <mat-icon>{{reportDictionary.examInternalReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.examExternalReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('examExternalReport')">
                  <span>
                    Exames externos
                  </span>
                  <mat-icon>{{reportDictionary.examExternalReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.internalPrescriptionReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('internalPrescriptionReport')">
                  <span>
                    Prescrições Padronizadas
                  </span>
                  <mat-icon>{{reportDictionary.internalPrescriptionReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.externalPrescriptionReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('externalPrescriptionReport')">
                  <span>
                    Prescrições não padronizadas
                  </span>
                  <mat-icon>{{reportDictionary.externalPrescriptionReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.listMemedPrescriptionPdf.listReport && reportDictionary.listMemedPrescriptionPdf.listReport.length > 0) {
              <div>
                <div class="report-select" (click)="viewListReport('listMemedPrescriptionPdf')">
                  <span>
                    Prescrições não padronizadas
                  </span>
                  <mat-icon>{{reportDictionary.listMemedPrescriptionPdf.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.procedureReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('procedureReport')">
                  <span>
                    Procedimentos médicos
                  </span>
                  <mat-icon>{{reportDictionary.procedureReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.sickNoteReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('sickNoteReport')">
                  <span>
                    Atestado
                  </span>
                  <mat-icon>{{reportDictionary.sickNoteReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.companionCertificateReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('companionCertificateReport')">
                  <span>
                    Atestado de Acompanhante
                  </span>
                  <mat-icon>{{reportDictionary.companionCertificateReport.viewed ? 'verified' : 'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.companionCertificateReport.listReport && reportDictionary.companionCertificateReport.listReport.length > 0) {
              <div>
                <div class="report-select" (click)="viewListReport('companionCertificateReport')">
                  <span>
                    Atestado de Acompanhante
                  </span>
                  <mat-icon>{{reportDictionary.companionCertificateReport.viewed ? 'verified' : 'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.isolationReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('isolationReport')">
                  <span>
                    Notificação de Isolamento
                  </span>
                  <mat-icon>{{reportDictionary.isolationReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.observationReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('observationReport')">
                  <span>
                    Ficha de Observação
                  </span>
                  <mat-icon>{{reportDictionary.observationReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.appointmentGuideReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('appointmentGuideReport')">
                  <span>
                    Guia de consulta
                  </span>
                  <mat-icon>{{reportDictionary.appointmentGuideReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.admissionGuideReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('admissionGuideReport')">
                  <span>
                    Guia de Internação
                  </span>
                  <mat-icon>{{reportDictionary.admissionGuideReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.feesGuideReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('feesGuideReport')">
                  <span>
                    Guia de honorários
                  </span>
                  <mat-icon>{{reportDictionary.feesGuideReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.spSadtGuideReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('spSadtGuideReport')">
                  <span>
                    Guia de SP/SADT
                  </span>
                  <mat-icon>{{reportDictionary.spSadtGuideReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.isolationAcknowledgeReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('isolationAcknowledgeReport')">
                  <span>
                    Declaração de ciência de isolamento
                  </span>
                  <mat-icon>{{reportDictionary.isolationAcknowledgeReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
            @if (reportDictionary.basicCareReport.report) {
              <div>
                <div class="report-select" (click)="viewReport('basicCareReport')">
                  <span>
                    Ficha de atendimento atenção básica
                  </span>
                  <mat-icon>{{reportDictionary.basicCareReport.viewed ? 'verified' :
                  'navigate_next'}}</mat-icon>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (isLoading) {
      <app-loading-progress-bar></app-loading-progress-bar>
    }
    <div class="footer-panel-modal-list">
      <div class="row button-container">
        <div class="col-6">
          @if (!isLoading) {
            <button mat-flat-button color="primary" class="btn-block"
            (click)="close()">Concluir</button>
          }
          @if (isLoading) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </div>
        <div class="col-6">
          @if (!isLoading) {
            <button mat-flat-button color="accent" class="btn-block"
            (click)="openAll()">Visualizar todos</button>
          }
          @if (isLoading) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </div>
      </div>
    </div>
  </div>
</div>